import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid, Input, Card } from 'semantic-ui-react';
import AddPurchaserAddress from './add';
import EditPurchaserAddress from './edit';
import DeletePurchaserAddress from './delete';
import Icon from '@material-ui/core/Icon';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class ViewAddress extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    load: false,
    message: '',
    purchaserAddress: [],
    maxWidth: 'md',
    addPurchaserAddress: false,
    editPurchaserAddress: false,
    deletePurchaserAddress: false,
  };

  componentDidMount() {
    this.getPurchaserAddress();
  }

  componentDidUpdate(props) {
    if (props.id != this.props.id) {
      this.getPurchaserAddress();
    }
  }

  getPurchaserAddress() {
    let context = this;
    context.setState({
      addPurchaserAddress: false,
      editPurchaserAddress: false,
      deletePurchaserAddress: false,
      load: true,
      message: 'Getting Purchaser Details'
    });
    let data1 = { 'purchaser_id': this.props.id }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/getpurchasersaddress.php',
      success: function(data)
      {
        console.log(data);
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            purchaserAddress: data,
            load: false,
            open: true
          });
        } catch (e) {
          context.setState({
            load: false,
            purchaserAddress: [],
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        console.log(e);
        context.setState({
          load: false,
          data: false
        });
      }
    });
  }

  handleClose = () => {
    this.setState({
      addPurchaserAddress: false,
      editPurchaserAddress: false,
      deletePurchaserAddress: false,
    });
  }

  render() {
    const { classes } = this.props;
    let add, edit;
    if (this.state.addPurchaserAddress) {
      add = (<AddPurchaserAddress addPurchaserAddress={this.state.addPurchaserAddress}
              handleClose={this.handleClose.bind(this)} id={this.props.id}
              getPurchaserAddress={this.getPurchaserAddress.bind(this)} />);
    }
    if (this.state.editPurchaserAddress) {
      edit = (<EditPurchaserAddress
                editid={this.state.editid} editaddress={this.state.editaddress}
                editstate={this.state.editstate} editgstn={this.state.editgstn}
                editPurchaserAddress={this.state.editPurchaserAddress}
                handleClose={this.handleClose.bind(this)}
                getPurchaserAddress={this.getPurchaserAddress.bind(this)} />);
    }
    return (
      <React.Fragment>
        <Dialog  fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}   open={this.props.viewAddress}
          onClose={this.props.handleClose}  aria-labelledby="max-width-dialog-title" >

          <DialogTitle id="max-width-dialog-title">Address</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Card fluid>
                <table width='100%' id='table'>
                  <tr id='tableheader'>
                    <th style={{width: '10%'}}><center>Sino</center></th>
                    <th style={{width: '30%'}}><center>Address</center></th>
                    <th style={{width: '15%'}}><center>State</center></th>
                    <th style={{width: '15%'}}><center>GSTN</center></th>
                    { this.props.menuPermission.edit ?
                      <th style={{width: '10%'}}><center>Edit</center></th>:''
                    }
                    
                  </tr>
                  { this.state.purchaserAddress.map((z) => {
                      return (
                        <tr>
                          <td><center>{z.sino}</center></td>
                          <td><center>{z.address}</center></td>
                          <td><center>{z.state}</center></td>
                          <td><center>{z.gstn}</center></td>
                          { this.props.menuPermission.edit ?
                            <td style={{ cursor: 'pointer', color: '#4F9CCD' }} onClick={ () => { this.setState({ editPurchaserAddress: true,
                              editid: z.id,
                              editaddress: z.address,
                              editstate: z.state,
                              editgstn: z.gstn }) } }>
                              <center>Edit</center>
                            </td>:''
                          }
                          
                        </tr>
                      );
                    }
                  )}
                </table>
                {add}{edit}
                <Card.Content extra>
                  { this.props.menuPermission.add ?
                    <Button  variant="outlined" color="primary"  onClick = { () => {this.setState({ addPurchaserAddress: true }) } } >
                      Add Address
                    </Button>:''
                  }
                </Card.Content>
              </Card>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

ViewAddress.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ViewAddress);
